module.exports = __webpack_public_path__ + "assets_app/img/key_back.c2586e82.svg";